import XLSX from 'xlsx';
import FileSaver from 'file-saver';

export default {
    data() {
        return {
            // 搜索条件
            form: {
                // 订单号
                code: '',
                // 商户订单号
                merchantCode: '',
                // 第三方支付单号
                thirdPartyCode: '',
                // 学员姓名
                name: '',
                // 身份证号
                idcard: '',
                // 所属单位
                company: '',
                // 订单总金额
                total: '',
                // 订单状态
                state: '',
                // 订单描述
                desc: '',
                // 支付方式
                payType: '',
            },
            // 支付方式
            payType: [
                {
                    value: [8,9],
                    label: '全部',
                },
                {
                    value: [9],
                    label: '支付宝',
                },
                {
                    value: [8],
                    label: '微信',
                },
            ],
            // 表格数据
            tableData: [],
            // 总条数
            total: 20,
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 10,
        }
    },
    methods: {
        search() {
            this.currentPage = 1;
            this.getMyorder();
        },



        // 每页显示条数改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.getMyorder();
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
            this.getMyorder();
        },

        //获取订单数据
        getMyorder() {
            let data = {
                token: this.$store.state.authority_management,
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                type_arr: [8,9],
                status: 1,
            }
            
            if(this.form.name){
                data.name = this.form.name
            }
            
            if(this.form.idcard){
                data.idcard = this.form.idcard
            }
            
            if(this.form.company){
                data.company = this.form.company 
            }
            
            if(this.form.payType){
                data.type_arr = this.form.payType 
            }
            
            this.$post("balance_record/find", data).then(res => {
                console.log(res.data.data.count)
                this.tableData = res.data.data.data;
                this.total = res.data.data.count;
                return res.data.data.data;
            });
        },

        // 在输入框输入数据时触发
        inputNumber(e) {
            e >= 20000 ? this.exceldata.length = 20000 : this.exceldata.length = e;
        },

       
    },
    filters: {
        orderStateFilter(value) {
            let str = value.split(' ')[0].split('-')[0];
            
            return str
        },
    },
    created() {
        this.getMyorder()

    },
}